export default class UniformCircuitOpenError extends Error {
  readonly retryAfterSeconds: number;

  constructor(retryAfterSeconds: number) {
    super('Uniform upstream circuit is open');
    this.name = 'UniformCircuitOpenError';
    this.retryAfterSeconds = retryAfterSeconds;
  }
}
